import React from 'react';

type SearchIconProps = {
    size?: number;
    className?: string;
};

export function SearchIcon(props: SearchIconProps) {
    return (
        <svg className={props.className} width={props.size} height={props.size} viewBox="0 0 14.6709 13.6572" fill="none" aria-hidden="true">
            <path
                d="M5.5 0C8.53757 0 11 2.46243 11 5.5C11 6.76379 10.572 7.92671 9.85547 8.85547L14.6709 13.6572L13.7529 13.6553C13.0408 13.6542 12.3562 13.3697 11.8516 12.8652L8.84766 9.86133C7.92017 10.5743 6.76028 11 5.5 11C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0ZM5.5 1.42969C3.2522 1.42969 1.42969 3.2522 1.42969 5.5C1.42969 7.7478 3.2522 9.57031 5.5 9.57031C7.7478 9.57031 9.57031 7.7478 9.57031 5.5C9.57031 3.2522 7.7478 1.42969 5.5 1.42969Z"
                fill="currentColor"
            />
        </svg>
    );
}
